export const unique = <T>(arr: T[], field?: string | ((item: T) => any)): (T | unknown)[] => {
  if (!field) {
    return [...new Set(arr)];
  }
  if (typeof field === 'function') {
    return [...new Set(arr.map(field))];
  }
  return [...new Set(arr.map((item) => item[field]))];
};